import { render, staticRenderFns } from "./PageFormBase.vue?vue&type=template&id=30061d2e"
import script from "./PageFormBase.vue?vue&type=script&lang=js"
export * from "./PageFormBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports